// @flow

if(!process.env.REACT_APP_API_AUTH_URL) throw new Error('API AUTH URL is missing.');
if(!process.env.REACT_APP_API_URL) throw new Error('API URL is missing.');

// Routes
const RoutesAPI = {

  // AUTH API ROUTES
  auth_login_path:               () => '/sign_in',
  auth_register_path:            () => '/',
  auth_logout_path:              () => '/sign_out',
  auth_request_password_path:    () => '/password',
  auth_reset_password_path:      () => '/password',
  auth_update_password_path:     () => '/password',
  auth_validate_token:           () => '/validate_token',
  auth_email_confirmation_path:  () => '/confirmation',
  auth_unlock_path:              () => '/unlock',
  auth_omniauth_redirect_url:    (origin: string) => '?auth_origin_url=' + origin + '/session/fetch-omniauth',

  // USER API ROUTES
  user_get:                      () => '/starfish_users.json',
  user_applications:             () => '/starfish_users/application/all.json',
  user_personal_info:            () => '/starfish_users/personal_info.json',
  set_notification:              () => '/starfish_users/settings',
  user_special_deals:            () => '/outbound_affiliates',
  send_destroy_mail:             () => '/starfish_users/send_destroy_mail',

  // OFFER API ROUTES
  offer_compare_offers:          () => '/starfish_compare_offers',
  offer_get_application:         (id: number) => '/starfish_users/application/' + id + '/offer.json',

  // SPECIAL DEALS ROUTES
  special_deals:                 () => '/outbound_affiliates',
  special_deals_recommend_deals: (limit: number) => '/outbound_affiliates/recommend_deals?limit=' + limit,

  // S3
  s3_creds_url:                  () => '/s3',
  s3_file_upload:                (bucket: string) => 'https://' + bucket + '.s3.amazonaws.com',
  attachment_save:               () => '/upload_attachments',
  attachment_preview:            (hash: string) => '/starfish_users_attachments/?hk=' + hash,

  // APPLICATIONS ROUTES
  get_applications:              () => '/starfish_users/',

  // APPLICATION COMPANIES
  mark_new_activities_as_seen:   (id: number) => '/mark_new_activities/' + id,

  // FAQ
  faq:                           () => '/starfish_users/faq',

  // REMINDER
  reminder:                      (ids: any) => '/starfish_users/reminders?application_company_ids=' + ids,

  get_scopes:                    () => '/starfish_users/scopes',
  set_scope:                     (id: number) => '/starfish_users/scopes/' + id,

  // DIRECT OFFERS
  create_stat:                   () => '/starfish_users/stats',

  // OutboundAffiliates
  outbound_affiliates:           () => '/outbound_affiliates'
};

export default RoutesAPI;



// WEBPACK FOOTER //
// ./src/api/Routes.js